'use client'

import { delmanTerms } from '@/features/delman/delmanTerms'
import { usePwaInstallPrompt } from '@/shared/hooks/usePwaInstallPrompt'

export function DelmanPwaInstallBanner() {
  const { canInstall, install, dismiss } = usePwaInstallPrompt()

  if (!canInstall) return null

  return (
    <div className="card border-primary/30 bg-primary-container/20 space-y-3">
      <div className="flex items-start gap-3">
        <span className="material-symbols-outlined text-primary text-2xl shrink-0">install_mobile</span>
        <div className="min-w-0 flex-1">
          <p className="text-body-sm font-semibold text-on-surface">{delmanTerms.pwa.installTitle}</p>
          <p className="text-label-md text-on-surface-variant mt-1">{delmanTerms.pwa.installBody}</p>
        </div>
      </div>
      <div className="flex gap-2">
        <button type="button" className="btn-primary flex-1 min-h-[44px]" onClick={() => void install()}>
          {delmanTerms.pwa.installAction}
        </button>
        <button type="button" className="btn-outline min-h-[44px] px-4" onClick={dismiss}>
          {delmanTerms.pwa.installDismiss}
        </button>
      </div>
    </div>
  )
}
